import { apiFetch } from "@/api/client";

/** PB-2 «Купує у нас» — read-only cache surface (TZ_PB2 v1.0 §C). */

export interface PurchasesBrand {
  brand_id?: string | null;
  brand_code_1c?: string | null;
  /** F1 tolerant render — name comes from the purchases row itself. */
  brand_name: string;
  is_strategic?: boolean;
  share_pct?: number | null;
  turnover_uah?: string | number | null;
  last_purchase_date?: string | null;
}

export interface Client360PurchasesResponse {
  status: "ok" | "no_data" | "pending";
  scope?: string | null;
  analyticalClientId?: string | null;
  analyticalClientType?: string | null;
  memberCount?: number | null;
  period?: string | null;
  brands?: PurchasesBrand[];
  lastPurchaseDate?: string | null;
  cycleDays?: number | null;
  frequency?: number | null;
  aovUah?: number | null;
  totalTurnoverUah?: number | null;
  trend?: "up" | "flat" | "down" | null;
  snapshotAt?: string | null;
  martSnapshotDate?: string | null;
  fetchedAt?: string | null;
  refreshPending?: boolean;
  allowedActions: { canRefresh: boolean; reason: string | null };
}

export function fetchClient360Purchases(
  holdingId: string,
  signal?: AbortSignal,
): Promise<Client360PurchasesResponse> {
  return apiFetch<Client360PurchasesResponse>(
    `/Custom/frontend/client360/${holdingId}/purchases`,
    { signal },
  );
}

export function requestPurchasesRefresh(
  holdingId: string,
): Promise<{ accepted: boolean; reason: string | null }> {
  return apiFetch(`/Custom/frontend/client360/${holdingId}/purchases/refresh`, {
    method: "POST",
    body: JSON.stringify({}),
  });
}
